<template>
  <div class="footer">
    <p v-if="copyright" class="trademark">{{ copyright }}</p>
    <div v-else>
      <p class="trademark">&copy;{{new Date().getFullYear()}} AMVAC Chemical Corporation. All Rights Reserved. <span class="line-break"></span><span class="divider">|</span> <a href="https://www.amvac.com/privacy-statement" target="_blank" rel="noopener noreferrer">Privacy&nbsp;Statement</a> <span class="divider">|</span> <a href="https://www.simpas.com/trademarks/" target="_blank" rel="noopener noreferrer">Trademarks</a></p>
      <p>AMVAC Chemical Corporation is a wholly owned subsidiary of American Vanguard&nbsp;Corporation.</p>
      <p>AZTEC, COUNTER, Force, SMARTCHOICE and Thimet are restricted use pesticides. Important: Always read and follow label instructions. See label for listed pests. Some products may not be registered for sale or use in all states or counties. Please check with your state agency responsible for pesticide registration to ensure registration status. All products are EPA&nbsp;registered.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    copyright: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
@import ../assets/sass/includes/variables
a
    color: $blue
.footer
    padding: 2rem
    p
        font-size: 0.88rem
        line-height: 1.1rem
    .trademark
      .line-break
        display: block
        +breakpoint($desk-sm)
          display: inline
      .divider
        &.divider--first
          display: none
          +breakpoint($desk-sm)
            display: inline-block
</style>